module.exports = __webpack_public_path__ + "img/popup7.4852acb5.png";